import React from 'react';
import ProjectCard from './ProjectCard';
import projectData from './data/projects.json';
import mlprojectData from './data/mlprojects.json';

import './Projects.css';
import MLProjectCard from "./MLProjectCard";

const Projects = () => {

    return (
        <section className="projects" id="projects">
            <h2 className="projects__heading section-heading">Projects</h2>
            {projectData.map((project, index) => (
                <ProjectCard
                    key={index}
                    title={project.title}
                    subtitle={project.subtitle}
                    description={project.description}
                    liveLink={project.liveLink}
                    codeLink={project.codeLink}
                    imageSrc={project.imageSrc}
                    imageClass={project.imageClass}
                    isReversed={project.isReversed}
                />
            ))}

            <h2 className="projects__heading section-heading">Machine Learning Projects</h2>
            
            {mlprojectData.map((project, index) => (
                <MLProjectCard
                key={index}
                title={project.title}
                subtitle={project.subtitle}
                description={project.description}
                codeLink={project.codeLink}
                />
            ))}
            <p className="projects__margin">

            </p>
        </section>
    );
};

export default Projects;